import { ref, computed, watch } from "@vue/composition-api";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment-timezone";
import store from "@/store";
import ability from "@/libs/acl/ability";
import { debounce } from "lodash";
import useFilterCounter from '@/components/Filters/useFiltersCount'

export default function useList() {
  const refListTable = ref(null);

  const toast = useToast();

  store.dispatch('luna_master_account/getAll')
  const lunaMasterAccountOptions = computed(() => store.getters['luna_master_account/getSelectedItems'])
  const lunaMasterAccountFilter = ref(null)

  store.dispatch('luna_list/getAll')
  const lunaListOptions = computed(() => store.getters['luna_list/getSelectedItems'])
  const lunaListFilter = ref(null)

  const genderOptions = ([
    { value: 0, label: 'Mujer'},
    { value: 1, label: 'Hombre'}
  ]);
  const genderFilter = ref(null)

  /*let ageOptions = ref([]);
  for (var i = 18; i < 99; i++) {
    ageOptions.value.push({value: i, label: i + " años" })
  }*/

  const ageOptions = ([
    {value: "18,29", label: '18 - 29 años'},
    {value: "30,49", label: '30 - 49 años'},
    {value: "50,69", label: '50 - 69 años'},
    {value: "70,89", label: '70 - 89 años'},
  ]);
  const ageFilter = ref(null)

  const tableColumns = [
    { label: 'luna.face.image', key: 'image', sortable: false },
    { label: 'luna.face.name', key: 'user_data', sortable: true },
    { label: 'luna.list.title', key: 'list_data', sortable: false, formatter: (value, key, item) => {
      if(item.lists) return [...new Set(item.lists.map(item => { return item.list_data}))].join(', ')
      return ''
      }
    },
    { label: 'luna.face.detection', key: 'detection', sortable: true },
    { label: 'luna.face.face_id', key: 'face_id', sortable: true },
    { label: 'luna.face.age', key: 'age', sortable: true },
    { label: 'luna.face.gender', key: 'gender', sortable: true, formatter: (value, key, item) => {
      if(item.gender) return 'Masculino'
      return 'Femenino'
      }
    },
    { label: 'luna.face.predominant_ethnicity', key: 'predominant_ethnicity', sortable: true },
    { label: 'luna.master_account.title', key: 'luna_master_account.name', sortable: true },
    { label: 'date.created_at', key: 'created_at', sortable: true, formatter: 'formatDateAssigned' },
    { label: 'date.updated_at', key: 'updated_at', sortable: true, formatter: 'formatDateAssigned' },
  ];
  if (
    ability.can("update", "LunaFace") == true ||
    ability.can("delete", "LunaFace") == true
  ) {
    tableColumns.splice(0, 0, { label: "actions.name", key: "actions" });
  }

  const perPage = ref(10);
  const totalList = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);

  const dataMeta = computed(() => {
    const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalList.value,
    };
  });

  const fetchList = (ctx, callback) => {
    store
      .dispatch("luna_face/getAll", {
        q: searchQuery.value,
        max: perPage.value,
        "page[n]": currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        luna_master_account: lunaMasterAccountFilter.value,
        list: lunaListFilter.value,
        gender: genderFilter.value,
        age: ageFilter.value,
      })
      .then((response) => {
        callback(response.data);
        totalList.value = response.meta.total;
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: "Error obteniendo la información",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  const formatDateAssigned = (value) => {
    const formattedDate = moment(value).format("DD/MM/YYYY HH:mm:ss");
    return formattedDate;
  };

  const refetchData = () => {
    refListTable.value.refresh();
  };

  watch([lunaMasterAccountFilter, lunaListFilter, genderFilter, ageFilter, currentPage, perPage, ], () => {
    refetchData();
  });

  watch([ searchQuery ], debounce(() => {
    refetchData()
  }, 500))

    // filters counter ============================
    const filters = ref({});
    const filtersCount = useFilterCounter(filters);
    const buildFilters = () => {
      filters.value = {
        luna_master_account: lunaMasterAccountFilter.value,
        list: lunaListFilter.value,
        gender: genderFilter.value,
        age: ageFilter.value,
      };
      refetchData();
    }
    const clearSearchFilters = () => {
      lunaMasterAccountFilter.value = null;
      lunaListFilter.value = null;
      genderFilter.value = null;
      ageFilter.value = null;
      buildFilters();
    }
    // ============================================

  return {
    tableColumns,
    perPage,
    currentPage,
    totalList,
    fetchList,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refListTable,
    formatDateAssigned,
    lunaMasterAccountOptions,
    lunaMasterAccountFilter,
    lunaListOptions,
    lunaListFilter,
    genderOptions,
    genderFilter,
    ageOptions,
    ageFilter,
    refetchData,
    filtersCount,
    clearSearchFilters,
    buildFilters,
  };
}
